<!-- Hero B2B -->
<section class="relative pt-16 pb-20 md:pt-24 md:pb-28 px-margin-mobile overflow-hidden bg-stone-bg">
  <div class="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
    <div class="absolute -top-20 -right-10 w-80 h-80 bg-primary/10 rounded-full blur-3xl animate-blob"></div>
    <div class="absolute bottom-0 left-0 w-64 h-64 bg-secondary-container/10 rounded-full blur-3xl animate-blob" style="animation-delay: 4s"></div>
  </div>

  <div class="container-max grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
    <div class="flex flex-col items-center lg:items-start text-center lg:text-left gap-6">
      <div class="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 text-primary rounded-full">
        <span class="material-symbols-outlined text-sm">business_center</span>
        <span class="font-mono text-label-mono uppercase">Reclutamiento con IA</span>
      </div>

      <h1 class="font-sans text-display-hero-mobile md:text-display-hero text-on-surface max-w-xl">
        Contrata más rápido con <span class="text-primary">IA</span>
      </h1>

      <p class="font-sans text-body-lg text-on-surface-variant max-w-md lg:max-w-lg">
        Candidatos filtrados por inteligencia artificial, en todos los sectores, en toda LATAM. Solo pagas un 10% de fee si contratas.
      </p>

      <div class="flex flex-col sm:flex-row w-full sm:w-auto gap-4 mt-2">
        <a [href]="demoLink" target="_blank" rel="noopener" class="btn-primary">
          <span class="material-symbols-outlined">calendar_month</span>
          Solicita demo
        </a>
        <a href="#planes" class="btn-secondary">Ver planes</a>
      </div>
    </div>

    <!-- Dashboard mockup -->
    <div class="relative bg-teal-surface rounded-[2rem] p-6 md:p-8 shadow-soft border border-primary/10 animate-float">
      <div class="bg-white rounded-2xl shadow-xl p-6 flex flex-col gap-5">
        <div class="flex justify-between items-center border-b border-surface-container-low pb-4">
          <h3 class="font-sans text-headline-md text-lg md:text-headline-md text-on-surface">Pipeline: Vendedor Sr.</h3>
          <span class="bg-primary/10 text-primary px-3 py-1 rounded-full text-xs font-bold shrink-0">12 nuevos</span>
        </div>

        <div class="flex flex-col gap-3">
          <div class="flex items-center justify-between p-4 bg-amber-highlight rounded-xl border border-secondary/20">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-full bg-secondary/20 text-secondary flex items-center justify-center font-bold shrink-0">MR</div>
              <div>
                <p class="font-bold text-sm text-on-surface">Mateo Rodríguez</p>
                <p class="text-xs text-slate-muted">Ventas B2B · CDMX</p>
              </div>
            </div>
            <div class="flex items-center gap-3 shrink-0">
              <div class="text-right">
                <p class="font-mono text-primary font-bold text-sm">98%</p>
                <p class="text-[10px] text-slate-muted">Match IA</p>
              </div>
              <button type="button" class="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                <span class="material-symbols-outlined text-lg">chevron_right</span>
              </button>
            </div>
          </div>
          <div class="flex items-center justify-between p-4 bg-white rounded-xl border border-outline-variant/30">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold shrink-0">LF</div>
              <div>
                <p class="font-bold text-sm text-on-surface">Lucía Fernández</p>
                <p class="text-xs text-slate-muted">Ventas retail · GDL</p>
              </div>
            </div>
            <div class="flex items-center gap-3 shrink-0">
              <div class="text-right">
                <p class="font-mono text-primary font-bold text-sm">92%</p>
                <p class="text-[10px] text-slate-muted">Match IA</p>
              </div>
              <button type="button" class="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                <span class="material-symbols-outlined text-lg">chevron_right</span>
              </button>
            </div>
          </div>
          <div class="flex items-center justify-between p-4 bg-white rounded-xl border border-outline-variant/30">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold shrink-0">CJ</div>
              <div>
                <p class="font-bold text-sm text-on-surface">Carla Jiménez</p>
                <p class="text-xs text-slate-muted">Atención a cliente · MTY</p>
              </div>
            </div>
            <div class="flex items-center gap-3 shrink-0">
              <div class="text-right">
                <p class="font-mono text-primary font-bold text-sm">85%</p>
                <p class="text-[10px] text-slate-muted">Match IA</p>
              </div>
              <button type="button" class="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                <span class="material-symbols-outlined text-lg">chevron_right</span>
              </button>
            </div>
          </div>
        </div>

        <div class="mt-1 p-4 bg-primary/5 rounded-xl border border-dashed border-primary/20 flex items-center gap-3">
          <div class="p-2 bg-primary rounded-lg text-white shrink-0">
            <span class="material-symbols-outlined text-lg">auto_awesome</span>
          </div>
          <p class="text-xs text-on-surface-variant italic">Recomendación: entrevista a Mateo en las próximas 24h.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Pain vs. Solution -->
<section class="section bg-stone-bg">
  <div class="container-max">
    <div class="text-center mb-14">
      <h2 class="font-sans text-headline-lg">Reclutamiento sin fricción</h2>
      <p class="text-on-surface-variant mt-2 max-w-2xl mx-auto">Comparamos el proceso tradicional frente a la agilidad de Chambia.</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <!-- Pain Card -->
      <div class="bg-white p-8 md:p-10 rounded-[2rem] border-l-8 border-error shadow-soft hover:-translate-y-1 transition-transform duration-300">
        <div class="flex items-center gap-4 mb-8">
          <div class="w-12 h-12 bg-error-container text-error rounded-full flex items-center justify-center shrink-0">
            <span class="material-symbols-outlined">error</span>
          </div>
          <h4 class="font-sans text-headline-md">El ayer (Manual)</h4>
        </div>
        <ul class="flex flex-col gap-6">
          <li class="flex gap-4 items-start">
            <span class="material-symbols-outlined text-error mt-1 shrink-0">remove_circle</span>
            <div>
              <p class="font-bold">Búsqueda manual en múltiples plataformas</p>
              <p class="text-slate-muted text-sm">Horas perdidas publicando y filtrando candidatos que no cumplen el perfil.</p>
            </div>
          </li>
          <li class="flex gap-4 items-start">
            <span class="material-symbols-outlined text-error mt-1 shrink-0">remove_circle</span>
            <div>
              <p class="font-bold">Semanas de espera</p>
              <p class="text-slate-muted text-sm">Procesos lentos que terminan en la pérdida de interés del talento.</p>
            </div>
          </li>
          <li class="flex gap-4 items-start">
            <span class="material-symbols-outlined text-error mt-1 shrink-0">remove_circle</span>
            <div>
              <p class="font-bold">CVs sin verificar</p>
              <p class="text-slate-muted text-sm">Información sin validar que alarga las entrevistas iniciales.</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- Solution Card -->
      <div class="bg-white p-8 md:p-10 rounded-[2rem] border-l-8 border-primary shadow-soft hover:-translate-y-1 transition-transform duration-300">
        <div class="flex items-center gap-4 mb-8">
          <div class="w-12 h-12 bg-primary-container text-white rounded-full flex items-center justify-center shrink-0">
            <span class="material-symbols-outlined">verified</span>
          </div>
          <h4 class="font-sans text-headline-md">El hoy (Chambia)</h4>
        </div>
        <ul class="flex flex-col gap-6">
          <li class="flex gap-4 items-start">
            <span class="material-symbols-outlined text-primary mt-1 shrink-0">check_circle</span>
            <div>
              <p class="font-bold">IA filtra y rankea automáticamente</p>
              <p class="text-slate-muted text-sm">Solo ves los mejores perfiles pre-calificados por nuestro matching.</p>
            </div>
          </li>
          <li class="flex gap-4 items-start">
            <span class="material-symbols-outlined text-primary mt-1 shrink-0">check_circle</span>
            <div>
              <p class="font-bold">Candidatos en 24-48h</p>
              <p class="text-slate-muted text-sm">Recibe perfiles calificados casi al instante de publicar tu vacante.</p>
            </div>
          </li>
          <li class="flex gap-4 items-start">
            <span class="material-symbols-outlined text-primary mt-1 shrink-0">check_circle</span>
            <div>
              <p class="font-bold">Verificación de identidad incluida</p>
              <p class="text-slate-muted text-sm">Candidatos validados desde el primer contacto por WhatsApp.</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- Features -->
<section class="section">
  <div class="container-max">
    <div class="text-center mb-14">
      <h2 class="font-sans text-headline-lg">Todo lo que necesitas para reclutar mejor</h2>
      <p class="text-on-surface-variant mt-2">Automatiza el proceso de contratación de principio a fin.</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      @for (f of features; track f.titulo) {
        <div class="bg-white rounded-3xl shadow-soft border border-outline-variant/30 p-8 flex gap-5 hover:shadow-primary-glow hover:-translate-y-1 transition-all duration-300">
          <div class="w-14 h-14 shrink-0 rounded-2xl bg-teal-surface text-primary flex items-center justify-center">
            <span class="material-symbols-outlined text-3xl">{{ f.icono }}</span>
          </div>
          <div>
            <h3 class="font-bold text-lg mb-1.5">{{ f.titulo }}</h3>
            <p class="text-on-surface-variant text-sm leading-relaxed">{{ f.descripcion }}</p>
          </div>
        </div>
      }
    </div>
  </div>
</section>

<!-- Caso de éxito -->
<section class="section bg-teal-surface">
  <div class="container-max max-w-3xl text-center relative">
    <span class="material-symbols-outlined text-6xl text-primary/30 mb-2" style="font-variation-settings: 'FILL' 1;">format_quote</span>
    <p class="font-sans text-body-lg italic mb-8 text-on-surface">
      "Con Chambia redujimos nuestro tiempo de contratación de 3 semanas a 4 días. La IA nos manda solo candidatos que realmente encajan con el puesto."
    </p>
    <div class="inline-flex items-center gap-3">
      <div class="w-12 h-12 rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold">MS</div>
      <div class="text-left">
        <div class="font-bold">María Elena Sánchez</div>
        <div class="text-on-surface-variant text-sm">HR Director &#64; Logística del Norte</div>
      </div>
    </div>
  </div>
</section>

<!-- Pricing -->
<section id="planes" class="section">
  <div class="container-max">
    <div class="text-center mb-14">
      <h2 class="font-sans text-headline-lg">Planes para empresas</h2>
      <p class="text-on-surface-variant mt-2">Elige el plan que se ajuste al tamaño de tu equipo de contratación.</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-center">
      @for (plan of planes; track plan.nombre) {
        <div
          class="bg-white p-8 md:p-10 rounded-[2rem] relative overflow-hidden flex flex-col transition-transform duration-300"
          [ngClass]="plan.destacado
            ? 'shadow-primary-glow border-2 border-primary md:-translate-y-4'
            : 'shadow-soft border border-outline-variant/40'"
        >
          @if (plan.destacado) {
            <div class="absolute top-0 right-0 bg-secondary text-white px-4 py-1.5 font-mono text-[10px] rounded-bl-2xl uppercase tracking-widest">
              Recomendado
            </div>
          }
          <h3 class="font-sans text-headline-md">{{ plan.nombre }}</h3>
          <p class="text-on-surface-variant mb-6 text-sm">{{ plan.descripcion }}</p>
          <div class="font-mono text-3xl mb-6" [class.text-secondary]="plan.destacado" [class.text-primary]="!plan.destacado">
            ${{ plan.precio }} <span class="text-sm font-medium text-on-surface-variant">{{ plan.moneda }}</span>
          </div>
          <ul class="space-y-3 mb-8 flex-1">
            @for (feature of plan.features; track feature) {
              <li class="flex items-center gap-2 text-sm">
                <span class="material-symbols-outlined text-lg" [class.text-secondary]="plan.destacado" [class.text-primary]="!plan.destacado">
                  {{ plan.destacado ? 'star' : 'check_circle' }}
                </span>
                {{ feature }}
              </li>
            }
          </ul>
          <a
            [href]="demoLink"
            target="_blank"
            rel="noopener"
            class="w-full py-3.5 rounded-full text-center font-bold transition-all"
            [ngClass]="plan.destacado
              ? 'bg-secondary text-white shadow-amber-glow hover:scale-[1.03]'
              : 'border-2 border-primary text-primary hover:bg-primary/5'"
          >
            {{ plan.cta }}
          </a>
        </div>
      }
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="section bg-stone-bg">
  <div class="container-max max-w-3xl">
    <h2 class="font-sans text-headline-lg text-center mb-12">Preguntas frecuentes para empresas</h2>
    <div class="flex flex-col gap-4">
      @for (faq of faqs; track faq.pregunta) {
        <div class="bg-white rounded-2xl border border-outline-variant/60 shadow-soft overflow-hidden">
          <button
            type="button"
            class="w-full p-5 flex justify-between items-center gap-4 cursor-pointer text-left hover:bg-surface-container-low/60 transition-colors"
            (click)="toggleFaq(faq)"
            [attr.aria-expanded]="faq.open"
          >
            <span class="font-bold text-sm">{{ faq.pregunta }}</span>
            <span class="material-symbols-outlined shrink-0 transition-transform text-primary" [class.rotate-180]="faq.open">expand_more</span>
          </button>
          @if (faq.open) {
            <div class="px-5 pb-5 text-on-surface-variant text-sm border-t border-outline-variant/30 pt-4">{{ faq.respuesta }}</div>
          }
        </div>
      }
    </div>
  </div>
</section>

<!-- CTA final -->
<section class="section pb-32 md:pb-section-gap">
  <div class="container-max bg-primary rounded-[3rem] p-10 md:p-20 text-center text-white relative overflow-hidden">
    <div class="absolute inset-0 opacity-10 pointer-events-none bg-grid-white"></div>
    <div class="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>
    <div class="absolute -bottom-10 -left-10 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>
    <div class="relative z-10 flex flex-col items-center gap-6">
      <h2 class="font-sans text-headline-lg max-w-lg">Empieza a contratar con IA hoy</h2>
      <p class="text-white max-w-md">
        Agenda una demo gratuita y descubre cómo Chambia acelera tu reclutamiento.
      </p>
      <a [href]="demoLink" target="_blank" rel="noopener" class="btn-whatsapp shadow-whatsapp-glow mt-2">
        <img src="assets/icons/whatsapp-icon.png" alt="" width="22" height="20" class="w-5 h-auto">
        Solicita demo por WhatsApp
      </a>
    </div>
  </div>
</section>
